import AllExperienceIcon from '@/../public/explore/allExperienceIcon.png';
import styled from '@emotion/styled';
import { Avatar, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { useLocationFilterModalAtom } from '../hooks/use-location-filter-modal';
import useSetMode from '../hooks/use-set-mode';
import BigFilterButton from './big-filter-button';
const StyledAvatar = styled(Avatar)`
  border-radius: 0;
  & > img {
    object-fit: contain;
  }
  max-width: fit-content;
`;

const AllExperiencesModeFilterButton = ({ active }: { active: boolean }) => {
  const setMode = useSetMode();
  const { setLocationFilterModal } = useLocationFilterModalAtom();
  const router = useRouter();
  const pathname = usePathname();

  const onClick = () => {
    setMode(undefined);
    router.push(pathname || '/explore/');

    setLocationFilterModal(false);
  };
  const startIcon = (
    <StyledAvatar
      src={AllExperienceIcon.src}
      style={{ borderRadius: 0, objectFit: 'contain' }}
    ></StyledAvatar>
  );
  const buttonImg = <Image src={AllExperienceIcon.src} alt={''} width={24} height={24} />;
  const isMobile = useMediaQuery('(max-width: 960px');
  return (
    <BigFilterButton
      className={active ? 'active' : ''}
      startIcon={isMobile ? null : startIcon}
      onClick={onClick}
      style={isMobile ? { padding: '0px', width: 'fit-content' } : {}}
    >
      <div>{isMobile ? buttonImg : null}&nbsp;</div>
      <div>{isMobile ? 'All' : 'All Experiences'}</div>
    </BigFilterButton>
  );
};

export default AllExperiencesModeFilterButton;
